import script from "./SuperMarioScene.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuperMarioScene.vue?vue&type=script&lang=ts&setup=true"

import "./SuperMarioScene.vue?vue&type=style&index=0&id=6774b403&lang=stylus"

const __exports__ = script;

export default __exports__